// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catalog-card-photo {
  flex: 1 1;
}
.catalog-card-photo__wrapper-img {
  position: relative;
}
.catalog-card-photo__img {
  height: calc((100vw - 13.75rem - 2.5rem) / 2);
  width: 100%;
  border-radius: 0.75rem;
  object-fit: cover;
  display: block;
  cursor: pointer;
}
.catalog-card-photo__icon {
  position: absolute;
  right: 1.5rem;
  top: 1.5rem;
}
.catalog-card-photo__carousel {
  margin-top: 1.5rem;
  position: relative;
  max-width: calc((100vw - 13.75rem - 2.5rem) / 2);
}
.catalog-card-photo__carousel-img {
  width: 100%;
  height: 100%;
  border-radius: 0.5rem;
  object-fit: cover;
  display: block;
  cursor: pointer;
  outline-offset: -3px;
  box-sizing: border-box;
}
.catalog-card-photo__carousel-img_active {
  outline: 3px solid rgba(var(--grey-400));
}
.catalog-card-photo__carousel-wrapper {
  padding: 0.25rem 0;
}
.catalog-card-photo__carousel-arrow {
  position: absolute;
  top: 3.5px;
  bottom: 3.5px;
  z-index: 2;
  background-color: rgba(var(--grey-100));
  width: 2.5rem;
  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  animation: 0.3s show ease;
}
.catalog-card-photo__carousel-arrow.-prev {
  box-shadow: 4px 0 4px 0 rgba(34, 37, 45, 0.15);
  left: -1px;
}
.catalog-card-photo__carousel-arrow.-next {
  box-shadow: -4px 0 4px 0 rgba(34, 37, 45, 0.15);
  right: -1px;
}
.catalog-card-photo__carousel-arrow-bg {
  width: 4px;
  background-color: transparent;
  position: absolute;
  top: 3.5px;
  bottom: 3.5px;
  animation: 0.3s show ease;
}
.catalog-card-photo__carousel-arrow-bg.-prev {
  left: -1px;
}
.catalog-card-photo__carousel-arrow-bg.-next {
  right: -1px;
}
.catalog-card-photo__carousel-arrow-bg::after {
  content: "";
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  right: 0;
  width: 0.25rem;
  background-color: rgba(var(--white));
}
.catalog-card-photo .swiper-slide {
  aspect-ratio: 1/1;
}

.mask {
  position: absolute;
  cursor: pointer;
  inset: 0;
  z-index: 10;
  background-color: rgba(var(--white));
  mask-size: 100%;
  mask-position: 100%;
  animation: show 1.5s ease;
}
.mask_right {
  mask-image: linear-gradient(to left, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.24), rgba(255, 255, 255, 0));
}
.mask_left {
  mask-image: linear-gradient(to right, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.24), rgba(255, 255, 255, 0));
}`, "",{"version":3,"sources":["webpack://./src/components/CatalogCardPhoto/styles.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;AACF;AACE;EACE,kBAAA;AACJ;AAEE;EACE,6CAAA;EACA,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAAJ;AAGE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;AADJ;AAIE;EACE,kBAAA;EACA,kBAAA;EACA,gDAAA;AAFJ;AAII;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,sBAAA;AAFN;AAIM;EACE,wCAAA;AAFR;AAMI;EACE,kBAAA;AAJN;AAOI;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,UAAA;EACA,uCAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AALN;AAOM;EACE,8CAAA;EACA,UAAA;AALR;AAQM;EACE,+CAAA;EACA,WAAA;AANR;AASM;EACE,UAAA;EACA,6BAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;AAPR;AASQ;EACE,UAAA;AAPV;AAUQ;EACE,WAAA;AARV;AAWQ;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,oCAAA;AATV;AAeE;EAEE,iBAAA;AAdJ;;AAkBA;EACE,kBAAA;EACA,eAAA;EACA,QAAA;EACA,WAAA;EACA,oCAAA;EACA,eAAA;EAEA,mBAAA;EACA,yBAAA;AAhBF;AAkBE;EACE,iHAAA;AAhBJ;AAwBE;EACE,kHAAA;AAtBJ","sourcesContent":[".catalog-card-photo {\n  flex: 1;\n\n  &__wrapper-img {\n    position: relative;\n  }\n\n  &__img {\n    height: calc(calc(100vw - 13.75rem - 2.5rem) / 2);\n    width: 100%;\n    border-radius: 0.75rem;\n    object-fit: cover;\n    display: block;\n    cursor: pointer;\n  }\n\n  &__icon {\n    position: absolute;\n    right: 1.5rem;\n    top: 1.5rem;\n  }\n\n  &__carousel {\n    margin-top: 1.5rem;\n    position: relative;\n    max-width: calc(calc(100vw - 13.75rem - 2.5rem) / 2);\n\n    &-img {\n      width: 100%;\n      height: 100%;\n      border-radius: 0.5rem;\n      object-fit: cover;\n      display: block;\n      cursor: pointer;\n      outline-offset: -3px;\n      box-sizing: border-box;\n\n      &_active {\n        outline: 3px solid rgba(var(--grey-400));\n      }\n    }\n\n    &-wrapper {\n      padding: 0.25rem 0;\n    }\n\n    &-arrow {\n      position: absolute;\n      top: 3.5px;\n      bottom: 3.5px;\n      z-index: 2;\n      background-color: rgba(var(--grey-100));\n      width: 2.5rem;\n      border-radius: 0.25rem;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      animation: 0.3s show ease;\n\n      &.-prev {\n        box-shadow: 4px 0 4px 0 rgba(34, 37, 45, 0.15);\n        left: -1px;\n      }\n\n      &.-next {\n        box-shadow: -4px 0 4px 0 rgba(34, 37, 45, 0.15);\n        right: -1px;\n      }\n\n      &-bg {\n        width: 4px;\n        background-color: transparent;\n        position: absolute;\n        top: 3.5px;\n        bottom: 3.5px;\n        animation: 0.3s show ease;\n\n        &.-prev {\n          left: -1px;\n        }\n\n        &.-next {\n          right: -1px;\n        }\n\n        &::after {\n          content: '';\n          position: absolute;\n          z-index: 1;\n          top: 0;\n          bottom: 0;\n          right: 0;\n          width: 0.25rem;\n          background-color: rgba(var(--white));\n        }\n      }\n    }\n  }\n\n  .swiper-slide {\n    // height: auto !important;\n    aspect-ratio: 1 / 1;\n  }\n}\n\n.mask {\n  position: absolute;\n  cursor: pointer;\n  inset: 0;\n  z-index: 10;\n  background-color: rgba(var(--white));\n  mask-size: 100%;\n\n  mask-position: 100%;\n  animation: show 1.5s ease;\n\n  &_right {\n    mask-image: linear-gradient(\n      to left,\n      rgba(255, 255, 255, 0.4),\n      rgba(255, 255, 255, 0.24),\n      rgba(255, 255, 255, 0)\n    );\n  }\n\n  &_left {\n    mask-image: linear-gradient(\n      to right,\n      rgba(255, 255, 255, 0.4),\n      rgba(255, 255, 255, 0.24),\n      rgba(255, 255, 255, 0)\n    );\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
